import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/components/ui/skeleton'
import { useSystemConfig } from '@/hooks/use-system-config'

export function AuthBrand() {
  const { t } = useTranslation()
  const { systemName, logo, loading } = useSystemConfig()

  return (
    <Link
      to='/'
      className='mb-4 flex items-center justify-center gap-3 transition-opacity hover:opacity-80'
    >
      {loading ? (
        <Skeleton className='size-10 rounded-full' />
      ) : (
        <img
          src={logo}
          alt={t('Logo')}
          className='size-10 -translate-y-[3px] rounded-full object-cover shadow-md ring-2 ring-blue-500/30'
        />
      )}
      {loading ? (
        <Skeleton className='h-12 w-44' />
      ) : (
        <span className='bg-gradient-to-r from-blue-600 to-violet-500 bg-clip-text text-5xl leading-none font-extrabold tracking-tight text-transparent dark:from-blue-400 dark:to-violet-400'>
          {systemName}
        </span>
      )}
    </Link>
  )
}
